import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "status-circle-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 2 }

import { computed, PropType } from 'vue';
import { ComputeTaskUtils } from '@/utils/compute-utils';
import { ComputeTaskType } from '@/gql/graphql';
import { BBadge, BTooltip } from 'bootstrap-vue-next';
import { COMPUTE_TASK_STATUS } from '@/constants';
import ProgressIndicatorThreeDots from '../ProgressIndicatorThreeDots.vue';

// --- Component Properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ComputeTaskStatusBadge',
  props: {
  task: { type: Object as PropType<ComputeTaskType> },
  iconOnly: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

// --- Component State ---
const errorMessage = computed(() =>
  props.task ? ComputeTaskUtils.errorMessage(props.task) : ''
);
const percentage = computed<number | null>(() => {
  if (!props.task) return null;
  const v = ComputeTaskUtils.progressPercentage(props.task);
  return typeof v === 'number' ? Math.round(v) : null;
});

const variant = computed(() => {
  if (!props.task) return 'secondary';
  return ComputeTaskUtils.progressVariant(props.task.status);
});

const isActive = computed(() => {
  if (!props.task) return false;
  return ComputeTaskUtils.progressActive(props.task.status);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (props.task)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (props.iconOnly)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                id: `task-status-${props.task.id}`,
                class: "status-cell"
              }, [
                (percentage.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      id: `task-status-${props.task.id}`,
                      class: _normalizeClass(["status-circle", [`text-${variant.value}`, { pulse: isActive.value }]]),
                      "aria-hidden": "false",
                      role: "img"
                    }, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(percentage.value) + "%", 1)
                    ], 10, _hoisted_2))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: _unref(ComputeTaskUtils).statusIcon(props.task.status),
                      class: _normalizeClass([[
            _unref(ComputeTaskUtils).statusIconClass(props.task.status),
            `text-${_unref(ComputeTaskUtils).progressVariant(props.task.status)}`,
          ], "status-icon"])
                    }, null, 8, ["icon", "class"]))
              ], 8, _hoisted_1),
              _createVNode(_unref(BTooltip), {
                target: `task-status-${props.task.id}`,
                triggers: "hover focus",
                class: "large-tooltip"
              }, {
                default: _withCtx(() => [
                  (props.task?.status === _unref(COMPUTE_TASK_STATUS).RUNNING)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(ComputeTaskUtils).progressTooltipText(props.task) ||
            props.task.status), 1))
                    : (
            props.task?.status === _unref(COMPUTE_TASK_STATUS).FAILED && errorMessage.value
          )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createElementVNode("span", null, _toDisplayString(props.task.status), 1),
                          (errorMessage.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, ": " + _toDisplayString(errorMessage.value), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.task.status), 1)),
                  (isActive.value)
                    ? (_openBlock(), _createBlock(ProgressIndicatorThreeDots, {
                        key: 3,
                        class: "ms-1",
                        style: {"font-size":"0.25rem","vertical-align":"middle"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["target"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (
          props.task?.status === _unref(COMPUTE_TASK_STATUS).RUNNING &&
          _unref(ComputeTaskUtils).progressTooltipText(props.task)
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(BBadge), {
                      variant: variant.value,
                      class: "text-wrap text-break text-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _unref(ComputeTaskUtils).statusIcon(props.task.status),
                          class: _normalizeClass(
              _unref(ComputeTaskUtils).statusIconClass(props.task.status).concat([
                'me-1',
              ])
            )
                        }, null, 8, ["icon", "class"]),
                        _createElementVNode("span", null, [
                          (_unref(ComputeTaskUtils).progressPercentage(props.task))
                            ? (_openBlock(), _createElementBlock("strong", _hoisted_9, _toDisplayString(_unref(ComputeTaskUtils).progressPercentage(props.task)) + "% ", 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(ComputeTaskUtils).progressTooltipText(props.task)), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["variant"])
                  ]))
                : (
          props.task?.status === _unref(COMPUTE_TASK_STATUS).FAILED && errorMessage.value
        )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_unref(BBadge), {
                        variant: _unref(ComputeTaskUtils).progressVariant(props.task.status),
                        class: "text-wrap text-break text-start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: _unref(ComputeTaskUtils).statusIcon(props.task.status),
                            class: _normalizeClass(
              _unref(ComputeTaskUtils).statusIconClass(props.task.status).concat([
                'me-1',
              ])
            )
                          }, null, 8, ["icon", "class"]),
                          _createElementVNode("span", null, _toDisplayString(props.task.status), 1),
                          (errorMessage.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, ": " + _toDisplayString(errorMessage.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["variant"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_unref(BBadge), {
                        variant: _unref(ComputeTaskUtils).progressVariant(props.task.status),
                        class: "text-wrap text-break text-start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: _unref(ComputeTaskUtils).statusIcon(props.task.status),
                            class: _normalizeClass(
              _unref(ComputeTaskUtils).statusIconClass(props.task.status).concat([
                'me-1',
              ])
            )
                          }, null, 8, ["icon", "class"]),
                          _createElementVNode("span", null, _toDisplayString(props.task.status), 1)
                        ]),
                        _: 1
                      }, 8, ["variant"])
                    ]))
            ], 64))
      ], 64))
    : _createCommentVNode("", true)
}
}

})